import { Directive, HostListener, Input } from '@angular/core';
import { Router } from '@angular/router';

//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
// RouteOnEnterDirective
//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
@Directive( { 
    selector : '[routeOnEnter]'
} )
export class RouteOnEnterDirective{
    @Input() routeOnEnter = "";

    //==================================
    // constructor
    //==================================
    constructor(router:Router){
        this.constructor.mapParams( this, arguments );
    }

    //==================================
    // @HostListener
    //==================================
    //host = hosting element (i.e the div this directive is attached to)        
    @HostListener( 'keydown', [ '$event' ] ) KeyDownEvent( e ){
        if( e.keyCode === 13 ){
            this.router.navigate([this.routeOnEnter]);   
        }
    }
} 

//Usage (if theere is one output/input that matches the selector name)
//<input (keyEnter)="doSomething();" />

//If selector is not the same as the single output/input name (only need parenthesis when out is an event emitter)
//<input routeOnEnter="routeName" />
